import { GridColDef } from "@mui/x-data-grid";
import { MutableRefObject } from "react";
import { GRID_CHECKBOX_SELECTION_COL_DEF, GridApi, GridCellCheckboxRenderer, GridHeaderCheckbox, GridRenderCellParams, gridFilteredSortedRowIdsSelector, selectedIdsLookupSelector } from "@mui/x-data-grid-pro";
import { GridRenderCellParamsPremium } from "@mui/x-data-grid-premium/typeOverloads";
import { GridColumnHeaderParams } from "@mui/x-data-grid-premium";

const CheckboxColumn = (apiRef: MutableRefObject<GridApi>): GridColDef => {
    return {
        ...GRID_CHECKBOX_SELECTION_COL_DEF,
        renderHeader: (
            params: GridColumnHeaderParams
        ) => {

            const allSelectableChildren = gridFilteredSortedRowIdsSelector(
                apiRef.current.state,
                apiRef.current.instanceId
            )?.filter((child) => apiRef.current.isRowSelectable(child));

            const selectionLookup = selectedIdsLookupSelector(
                apiRef.current.state,
                apiRef.current.instanceId
            );

            const noIndeterminateState = false;

            const checked = allSelectableChildren === undefined || allSelectableChildren.length === 0 ? false :
                allSelectableChildren?.every(
                    (child) => selectionLookup[child] !== undefined
                );

            const checkboxParamsData: GridColumnHeaderParams & {
                indeterminate?: boolean;
                checked?: boolean;
                disabled?: boolean;
                onClick?: (e: MouseEvent) => void;
            } = {
                ...params,
                onClick: (e: any) => {
                    apiRef.current.selectRows(allSelectableChildren, !checked);
                    e.preventDefault();
                },
                indeterminate: noIndeterminateState,
                checked,
            };
            return <GridHeaderCheckbox {...checkboxParamsData} />;
        },
        renderCell: (
            params: GridRenderCellParams & GridRenderCellParamsPremium
        ) => {

            const { rowNode } = params;

            if (!apiRef.current.isRowSelectable(params.id))
                return <></>;

            if (rowNode.type !== "group")
                return <GridCellCheckboxRenderer {...params} />;

            const selectionLookup = selectedIdsLookupSelector(
                apiRef.current.state,
                apiRef.current.instanceId
            );

            const allSelectableChildren = apiRef.current.getRowGroupChildren({
                groupId: rowNode.id,
                applyFiltering: true,
                applySorting: true,
            })?.filter((child) => apiRef.current.isRowSelectable(child));

            if (allSelectableChildren === undefined || allSelectableChildren.length === 0)
                return <GridCellCheckboxRenderer {...params} />;

            const noIndeterminateState = false;

            const checked = selectionLookup[rowNode.id] !== undefined;

            const allChildrenChecked = allSelectableChildren?.every((child) => selectionLookup[child] !== undefined);

            const someChildrenChecked = allSelectableChildren?.some((child) => selectionLookup[child] === undefined) &&
                allSelectableChildren?.some((child) => selectionLookup[child] !== undefined);

            const noneChildrenChecked = allSelectableChildren?.every((child) => selectionLookup[child] === undefined);


            const checkboxParamsData: GridRenderCellParams &
                GridRenderCellParamsPremium & {
                    indeterminate?: boolean;
                    checked?: boolean;
                    disabled?: boolean;
                    onClick?: (e: MouseEvent) => void;
                } = {
                ...params,
                disabled: false,
                onClick: (e: any) => {
                    if (e?.target.checked === false && rowNode.type === "group" && allSelectableChildren && (someChildrenChecked || noneChildrenChecked)) {
                        apiRef.current.selectRows(allSelectableChildren, noIndeterminateState || !allChildrenChecked);
                        e.preventDefault();
                    } else if (e?.target.checked === false && rowNode.type === "group" && allSelectableChildren && allChildrenChecked) {
                        apiRef.current.selectRows([rowNode.id], false);
                        e.preventDefault();
                    } else if (e?.target.checked === true && rowNode.type === "group" && allSelectableChildren && allChildrenChecked) {
                        apiRef.current.selectRows(allSelectableChildren, false);
                        e.preventDefault();
                    }
                },
                indeterminate: noIndeterminateState,
                checked,
            };

            return <>
                <GridCellCheckboxRenderer {...checkboxParamsData} />
            </>
        }
    }
}

export default CheckboxColumn;